const rightTemplate = {};

/**
 * All sections section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentAllSection = () => {
  const allSelector = document.querySelectorAll('.configurator');
  if (!allSelector) return '';
  return allSelector;
};

/**
 * Special Instructions section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentSpecialInstructionsSection = (element) => {
  const specialInstructionsSelector = selectElementByAttr(
    element,
    'data-groupcode',
    'Special instructions',
  );
  if (!specialInstructionsSelector) return '';
  return getParentDiv(specialInstructionsSelector);
};

/**
 * Warranty section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentWarrantySection = (element) => {
  const warrantySelector = selectElementByAttr(element, 'data-groupcode', 'additional warranty');
  if (!warrantySelector) return '';
  return getParentDiv(warrantySelector);
};

/**
 * Impressions section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentImpressionsSection = (element) => {
  const impressionSelector = selectElementByAttr(element, 'data-groupcode', 'impressions');
  if (!impressionSelector) return '';
  return getParentDiv(impressionSelector);
};

/**
 * Options section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentOptionsSection = (element) => {
  const optionSelector = selectElementByAttr(element, 'data-groupcode', 'color dot');
  if (!optionSelector) return '';
  return getParentDiv(optionSelector);
};

/**
 * Audiogram section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentAudiogramSection = (element) => {
  const audiogramContainer = element.querySelector('#cssConfigureAudiogram');
  return getParentDiv(audiogramContainer);
};

/**
 * Color section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentColorSection = (element) => {
  const colorSelectors = [
    ...element.querySelectorAll('[id*="ColourPickerContainer"]'),
    ...element.querySelectorAll('[id*="ColorPanel"]'),
  ];
  // If no color selector found
  if (colorSelectors.length === 0) return '';
  return getParentDiv(colorSelectors[0]);
};

/**
 * Charger section
 * @param {Element} element
 * @returns {String}
 */
/* eslint-disable-next-line */
rightTemplate.contentChargerSection = (element) => {
  // TODO
  // NOTE: Cannot find ITE Charger
  return ``;
};

/**
 * Power Level section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentPowerLevelSection = (element) => {
  const powerSelector =
    selectElementByAttr(element, 'data-groupcode', 'power') ||
    selectElementByAttr(element, 'data-featurekey', 'power');
  // If no power selector found
  if (!powerSelector) return '';
  // get and return parent div
  return getParentDiv(powerSelector);
};

/**
 * Patient name section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentPatientNameSection = (element) => {
  const patientSection = element.querySelector('.configurePatientInfo');
  const patientSectionHiddenField = element.querySelector(
    '.configurePatientInfo + input[type="hidden"]',
  );
  return `
        ${patientSection ? patientSection.outerHTML : ''}
        ${patientSectionHiddenField ? patientSectionHiddenField.outerHTML : ''}
    `;
};

/**
 * Order type section
 * @param {Element} element
 * @returns {String}
 */
rightTemplate.contentOrderTypeSection = (element) => {
  const selectorElement = element.querySelector('.configurator__selector');
  return `
        ${selectorElement ? selectorElement.outerHTML : ''}
    `;
};

/**
 * Product detail section
 * @param {Element} element
 * @returns {String}
 */
/* eslint-disable-next-line */
rightTemplate.contentProductDetailSection = (element) => {
  console.log('rightTemplate.contentProductDetailSection');
  return `
    <!-- new -->
    <p class="product_brand" id="Brand">AUDIGY</p>
    <!-- new -->
    <h2 class="product_name" id="ProductName">AGXR-H</h2>
    <!-- new -->
    <p class="product_number small" id="ProductNumber">H961-DRW - 20967573</p>
    <!-- new -->
    <ul class="product_features">
    <li>Feature</li>
    </ul>
    <!-- new -->
    <p class="product_guide-link">
        <a href="#documentations">
            <i class="eva eva-file-outline"></i>See user guide & Datasheet
        </a>
    </p>
    `;
};

const selectElementByAttr = (element, attr, value) => {
  const selectors = [...element.querySelectorAll(`[${attr}]`)];
  const selectorElement = selectors.filter(
    (el) => el.getAttribute(attr).toLowerCase() === value.toLowerCase(),
  );
  return selectorElement[0];
};

const getParentDiv = (element) => {
  const parentDiv = element?.closest('.configurator__section');
  return `
        ${parentDiv ? parentDiv.outerHTML : ''}
    `;
};

export default rightTemplate;
